import { render, staticRenderFns } from "./dealer_link.vue?vue&type=template&id=0ffa0698&scoped=true&"
import script from "./dealer_link.vue?vue&type=script&lang=js&"
export * from "./dealer_link.vue?vue&type=script&lang=js&"
import style0 from "./dealer_link.vue?vue&type=style&index=0&id=0ffa0698&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffa0698",
  null
  
)

export default component.exports